import styled from "styled-components";

export const Title = styled.h1`
  text-align: center;
  font-size: 64px;
  position: relative;
  top: -20px;
  font-weight: 700;
  margin: 0;
`;

export const Description = styled.h2`
  font-weight: 400;
  width: 60%;
  text-align: center;
  font-size: 26px;
  position: relative;
  top: -30px;
`;
